import React, { useState } from 'react';
import { Mousewheel, Keyboard, Pagination } from 'swiper';
import { Swiper, SwiperSlide, } from 'swiper/react';
import Feature from './components/feature';
import Introduce from './components/introduce'
import Shareic from './components/shareic'
import Homevd from './components/homevd'
import BottomTab from './components/bottomtab'
import './index.scss';
import 'swiper/css';
import 'swiper/css/mousewheel';
import "swiper/css/pagination";
import Header from './components/header';

const App = () => {
  const [current, setCurrent] = useState(0)
  const [showBottomTab, setShowBottomTab] = useState(false)
  const changeSlide = (e) => {
    setCurrent(e?.activeIndex)
    setShowBottomTab(false)
  }
  const openCopyRight = () => {
    // if (current === 0) return
    setShowBottomTab(true)
  }
  const closeBottom = () => {
    setShowBottomTab(false)
  }
  // const navClick = (index) => {
  //   console.log('index', index)
  //   setCurrent(index)
  //   slideTo(index)
  // }
  const [swiper, setSwiper] = useState(null);

  const slideTo = (index) => {
    if (swiper) {
      swiper.slideTo(index)
    }
  };
  const setActive = (index) => {
    slideTo(index)
    setCurrent(index)
  }

  return (
    <div className="home">
      <div className='inner'>
        <Header setActiveMenu={setActive} activeMenu={current} />
        <Swiper
          speed={600} //匀速时间，根据实际情况调节
          direction='vertical'
          modules={[Pagination,Mousewheel, Keyboard]}
          mousewheel={{
            sensitivity: .1,
            forceToAxis: true
          }}
          // mousewheel={true}
          // keyboard={{ enabled: true }}
          keyboard={{
            enabled: true,
            onlyInViewport: false,
            pageUpDown: true
          }}
          // effect={"fade"}
          allowTouchMove={false}  // 禁止触摸滑动
          autoHeight={true}
          onSlideChange={(e) => changeSlide(e)}
          onSwiper={setSwiper}
          pagination={{
            clickable: true,
            bulletClass: 'swiper-pagination-bullet main-vertical-bullet',
            bulletActiveClass: 'swiper-pagination-bullet-active main-vertical-bullet-active'
          }}
        >
          <SwiperSlide className='page-slide'><Homevd next={() => slideTo(1)} /></SwiperSlide>
          <SwiperSlide className='page-slide'><Feature /></SwiperSlide>
          <SwiperSlide className='page-slide'><Introduce /></SwiperSlide>
          <SwiperSlide className='page-slide'><Shareic /></SwiperSlide>
        </Swiper>
      </div>
      <div className={`copyright absolute bottom-0 z-10 left-2/3 active`} onClick={openCopyRight}>
        Copyright Information<img className='inline-block origin-center -rotate-180' src="https://starvr-cdn.starmakerstudios.com/webimg/home/web_img_fanye.png" alt="" />
      </div>
      <BottomTab showBottomTab={showBottomTab} close={() => closeBottom()} />
      {/* {current !== 0 && (
        <Nav current={current} navClick={navClick} />
      )} */}
    </div>
  );
}

export default App;
